import { toUrlParameters } from './util';
export class DefinedMessageRemoteRepository {
    constructor(fetcher, contextId) {
        this.fetcher = fetcher;
        this.contextId = contextId;
    }
    async fetchAll() {
        const params = {
            contextId: this.contextId,
            active: true
        };
        const responses = await this.fetcher.fetchGetJson(`${DefinedMessageRemoteRepository.DEFINED_MESSAGES_PATH}?${toUrlParameters(params)}`);
        return responses.map(response => DefinedMessageRemoteRepository.mapResponseToSavedMessage(response));
    }
    async save(definedMessage) {
        const saveRequest = DefinedMessageRemoteRepository.mapDefinedMessageToSaveRequest(definedMessage);
        return await this.fetcher.fetchPostJson(DefinedMessageRemoteRepository.DEFINED_MESSAGES_PATH, saveRequest);
    }
    async remove(definedMessage) {
        return await this.fetcher.fetchDeleteJson(`${DefinedMessageRemoteRepository.DEFINED_MESSAGES_PATH}/${definedMessage.id}`);
    }
    async reorder(orderedIds) {
        await this.fetcher.fetchPutJson(`${DefinedMessageRemoteRepository.DEFINED_MESSAGES_PATH}/reorder`, orderedIds);
    }
    static mapDefinedMessageToSaveRequest(definedMessage) {
        return {
            id: definedMessage.id,
            contextId: definedMessage.contextId,
            type: definedMessage.type,
            html: definedMessage.html,
            text: definedMessage.text
        };
    }
    static mapResponseToSavedMessage(response) {
        return response;
    }
}
DefinedMessageRemoteRepository.DEFINED_MESSAGES_PATH = '/api/defined-messages';
